<a [routerLink]="[newsItemRouteLinkPrefix, newsItem.id]">
  <mat-card>
    <img [src]="newsItem.featuredImageUrl" />
    <p>{{newsItem.title}}</p>
  </mat-card>
</a>
